import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import $ from 'jquery';
import DailyAsrUsageReport from './DailyAsrUsageReport';
import MonthlyAsrUsageReport from './MonthlyAsrUsageReport';
import WeeklyAsrUsageReport from './WeeklyAsrUsageReport';

class AsrReportTabSetting extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-asr/reports";
      var path1 = window.origin + "/platform/cloud-asr/reports/";
      if (currentPath === path || currentPath === path1) {
        $("#asr-daily-report").addClass('active');
      } else if (currentPath.includes("/cloud-asr/reports/monthly-reports")) {
        $("#asr-monthly-report").addClass('active');
      } else if (currentPath.includes("/cloud-asr/reports/weekly-reports")) {
        $("#asr-weekly-report").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#asr-daily-report,#asr-monthly-report, #asr-weekly-report")
        .on("click", function () {
          $("#asr-daily-report,#asr-monthly-report, #asr-weekly-report")
            .removeClass('active');
          localStorage.setItem("last-asr-report-tab", $(this)[0].id);
          $(this).addClass('active')
        })
    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
            <div className="content-header" >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-5">
                    <h1 className="m-0 page-title">Reports </h1>
                    {/* <h6 className="taglineTxt">Build Interact &amp; Distribute</h6> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid" style={{ marginLeft: '10px' }}>
              <div className="border-bottom"></div>
              {/* Nav tabs */}
              <div className="tab-class" >
                <ul className="nav nav-tabs border-bottom navCluster">
                  <Link to="/cloud-asr/reports" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="asr-daily-report">Daily Reports</li>
                  </Link>
                  <Link to="/cloud-asr/reports/weekly-reports" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="asr-weekly-report">Weekly Reports</li>
                  </Link>
                  <Link to="/cloud-asr/reports/monthly-reports" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="asr-monthly-report">Monthly Reports</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <Switch>
            <Route path="/cloud-asr/reports/weekly-reports" component={WeeklyAsrUsageReport}></Route>
            <Route path="/cloud-asr/reports/monthly-reports" component={MonthlyAsrUsageReport}></Route>
            <Route path="/cloud-asr/reports" component={DailyAsrUsageReport}></Route>
          </Switch>
        </div>
      </Router>

    );
  }
}
export default AsrReportTabSetting;


// WEBPACK FOOTER //
// ./src/asrUi/reports/AsrReportTabSetting.js